import React from 'react'
import { Grid, Button, Typography, FormControl, FormHelperText } from '@material-ui/core'
import PlusLoadQuantityInput from '../comps/PlusLoadQuantityInput'
import Alert from '../comps/Alert'
import cn from 'classnames'

export function getPlusLoadInitialTitle() {
  return `Get a Plus Load`
}
export function getPlusLoadInitialContent(options: { phoneNumber: any, classes: any, onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void, onCallBoral: () => void, quantity: number | undefined}) {
  const { classes, onInputChange, onCallBoral, quantity } = options
  return (
    <React.Fragment>
      <Typography variant='body1' className={cn(classes.marginTop2unit, classes.marginBottom2unit)}>
        { `How much do you want in your plus load?` }
      </Typography>
      <div className={cn(classes.displayFlex, classes.positionRelative)}>
        <span className={cn(classes.largePlus)}>+</span>
        <FormControl>
          <PlusLoadQuantityInput
            value={quantity}
            classes={classes}
            onChange={onInputChange}
          />
          <FormHelperText>{ `Max 7 m³, min 0.1 m³.` }</FormHelperText>
        </FormControl>
      </div>
      <div className={cn(classes.marginTop2unit)}>
        <Alert
          content={
            <React.Fragment>
              <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
                { `1 plus load per order can be booked via Boral Connects. For additional plus loads, large loads (more than 7 m³) or minus loads (less than 0 m³) please ` }
              </Typography>
              <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText, classes.fontWeight500)} component='span'>
                <a
                  className={cn(classes.textDecorationUnderline, classes.cursorPointer, classes.hyperlink, classes.callBoral)}
                  onClick={onCallBoral}
                >
                  Call Boral{options.phoneNumber ? ` (${options.phoneNumber})` : ''}
                </a>
              </Typography>
              <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
                { `.` }
              </Typography>
            </React.Fragment>
          }
        />
      </div>
    </React.Fragment>
  )
}

export function getPlusLoadInitialFooter(options: { classes: any, onCancel: () => void, onNext: () => void, isQuantityValid: boolean}) {
  const { classes, onCancel, onNext, isQuantityValid } = options
  return (
    <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
      <Grid className={classes.flexGrow1} item>
        <Button
          className={classes.button}
          onClick={onCancel}
          variant='outlined'
        >
          { `Cancel` }
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.button}
          color='primary'
          onClick={onNext}
          variant='contained'
          disabled={!isQuantityValid}
        >
          { `Next Step` }
        </Button>
      </Grid>
    </Grid>
  )
}
